var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"file-avatar"},[_c(_vm.previewComponent.tag,_vm._b({tag:"component"},'component',_vm.previewComponent.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }